// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__ACE10","resendInfoText":"OnGoingPaymentBox_resendInfoText__26bp6"};